import "./intro.css";
import IntroImg from "../../img/intro-image.png";
import IntroImgMobile from "../../img/intro-img-mobile.png";
import { content } from "../../content/landingContent";

const Intro = () => {
  const { headline, paragraphs } = content.intro;

  return (
    <section id="intro">
      <div className="i">
        <div className="i-left">
          <div className="i-left-wrapper">
            <div className="i-intro">{headline}</div>

            <div className="image-container">
              <img src={IntroImgMobile} alt="" className="mobile-img" />
            </div>

            <div className="i-desc">
              {paragraphs.map((paragraph, index) => (
                <div key={index}>
                  {paragraph.breakBefore ? <br /> : null}
                  <p className={paragraph.className}>
                    {paragraph.bold ? (
                      <b> {paragraph.text} </b>
                    ) : (
                      paragraph.text
                    )}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="i-right">
          <img src={IntroImg} alt="" className="desktop-img" />
        </div>
      </div>
    </section>
  );
};

export default Intro;
